import { useRouter } from "next/router";
import { Button } from "./Buttons";

export function EmptyState(props: { title?: string; subTitle?: string }) {
  const router = useRouter();
  return (
    <>
      <div data-testid="empty-state" className="flex justify-center flex-col items-center h-full gap-4">
        <div className="text-center flex flex-col items-center">
          <img
            className="inline-block h-[40px] w-[40px] grayscale"
            src={"/images/marteye.png"}
            alt="marteye logo"
          />

          <h3 className="mt-2 text-sm font-semibold text-gray-900">
            {props.title ?? "Nothing here yet..."}
          </h3>
          <p className="mt-1 text-sm text-gray-500">
            {props.subTitle ?? "We are still working on this feature."}
          </p>
        </div>

        <Button variant="tertiary" onClick={() => router.back()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2.5}
            stroke="currentColor"
            className="mx-auto h-5 w-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
            />
          </svg>
          Go Back
        </Button>
      </div>
    </>
  );
}
